<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select v-model="query.fState" style="width: 90px" size="small" clearable>
        <el-option value="未确认">未确认</el-option>
        <el-option value="已确认">已确认</el-option>
        <el-option value="已关闭">已关闭</el-option>
      </el-select>
      <el-input v-model="query.fCkBillNo" placeholder="出仓单号" size="small" style="width:150px;" clearable />
      <el-input v-model="query.fOrderNo" placeholder="订单编号" size="small" style="width:150px;" clearable />
      <el-input v-model="query.fBillNo" placeholder="应收单号" size="small" style="width:150px;" clearable />
      <el-input v-model="query.fDistributor" placeholder="经销商" size="small" style="width:170px;" clearable />
      <el-input v-model="query.customer" placeholder="客户名称" size="small" style="width:170px;" clearable />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction; column;overflow: auto">
      <el-table v-loading="loading" v-el-table-height-fix :data="tableData" height="100%" @row-dblclick="_view">
        <el-table-column prop="fBillNo" label="应收单号" width="150px" />
        <el-table-column prop="fOrderNo" label="订单编号" width="140px" />
        <el-table-column prop="fCkBillNo" label="出仓单号" width="140px" />
        <el-table-column prop="fDistributor" label="经销商名称" min-width="160px" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="160px" />
        <el-table-column prop="fOrderAmount" label="总金额" width="100px" />
        <!--<el-table-column prop="fDeductionRatio" label="收款比例(%)" width="100px" />-->
        <el-table-column prop="fAmount" label="应收金额" width="100px" />
        <el-table-column prop="fState" label="状态" width="65px" />
        <el-table-column prop="fCreateTime" label="订单日期" width="100px" />
        <el-table-column label="操作" class-name="table-oper-col" width="95px">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
            </template>
            <ConfirmButton v-if="scope.row.fState == '已确认' &&canUnudit" @confirm="_unaudit(scope.row)">反确认</ConfirmButton>
            <ConfirmButton v-if="scope.row.fState == '关闭' &&canUnudit" @confirm="_unclose(scope.row)">反关闭</ConfirmButton>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        fState: '未确认',
        fBillNo: null,
        fOrderNo: null,
        fCkBillNo: null,
        fDistributor: null,
        customer: null,
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      canUnudit: true,
      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    const userGrants = this.$store.state.userInfo.userGrants
    userGrants.forEach((val) => {
      if (val.key == '007011003') {
        this.canUnudit = val.isGrant
      }
    })
    this.refresh()
  },
  activated() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('OrderManage/ArBill/ArBillEntry', this.query).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    _view: async function(row) {
      var url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    },
    _unaudit: function(row) {
      this.loading = true
      this.$httpPost('OrderManage/ArBill/ArBillUnConfirm', {
        fid: row.fid
      }).then((res) => {
        if (!res.isSuccess) {
          this.loading = false
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        this.refresh()
      })
    },
    _unclose: function(row) {
      this.loading = true
      this.$httpPost('OrderManage/ArBill/ArBillUnClose', {
        fid: row.fid
      }).then((res) => {
        if (!res.isSuccess) {
          this.loading = false
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        this.refresh()
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/ArBillDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>
